import { useEffect, useState } from 'react'
import { Card, Button, Upload, Image, message, Spin } from 'antd'
import { UploadOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons'
import type { UploadProps } from 'antd/es/upload'
import { confirmDelete } from '../../hooks/useConfirm'
import { companyCertAPI, uploadAPI } from '../../api'

const CompanyCertManagement = () => {
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [imageUrl, setImageUrl] = useState('')

  useEffect(() => {
    fetchCert()
  }, [])

  const fetchCert = async () => {
    setLoading(true)
    try {
      const res = await companyCertAPI.getCompanyCert()
      if (res.code === 200 && res.data) {
        setImageUrl(res.data.imageUrl || '')
      }
    } catch (error) {
      // 错误由 request 拦截器统一处理
    } finally {
      setLoading(false)
    }
  }

  const handleUpload: UploadProps['customRequest'] = async (options) => {
    const { file, onSuccess, onError } = options
    try {
      const res = await uploadAPI.uploadImage(file as File)
      if (res.code === 200) {
        setImageUrl(res.data.url)
        onSuccess?.({ url: res.data.url })
        message.success('上传成功')
      } else {
        throw new Error(res.message || '上传失败')
      }
    } catch (error) {
      onError?.(error as Error)
      message.error('上传失败')
    }
  }

  const handleDelete = () => {
    confirmDelete('公司证件图片', '系统设置', () => {
      setImageUrl('')
      message.success('已删除图片')
    }, '删除后需要重新上传证件图片。')
  }

  const handleSave = async () => {
    if (!imageUrl) {
      message.warning('请上传证件图片')
      return
    }
    setSaving(true)
    try {
      const res = await companyCertAPI.saveCompanyCert({ imageUrl })
      if (res.code === 200) {
        message.success('保存成功')
      }
    } catch (error) {
      message.error('保存失败')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Spin spinning={loading}>
      <Card
        title="公司证件"
        extra={
          <Button type="primary" icon={<SaveOutlined />} onClick={handleSave} loading={saving}>
            保存
          </Button>
        }
      >
        {imageUrl ? (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <Image src={imageUrl} width={300} style={{ border: '1px solid #f0f0f0', borderRadius: 4 }} />
            <Button
              type="link" danger icon={<DeleteOutlined />} size="small"
              style={{ position: 'absolute', top: -8, right: -8 }}
              onClick={handleDelete}
            />
          </div>
        ) : (
          <Upload customRequest={handleUpload} maxCount={1} accept="image/*" showUploadList={false}>
            <Button icon={<UploadOutlined />}>上传公司证件</Button>
          </Upload>
        )}
        <div style={{ marginTop: 16, fontSize: 12, color: '#999' }}>
          上传营业执照、食品经营许可证等证件图片，将展示在小程序「我的」-「公司证件」页面
        </div>
      </Card>
    </Spin>
  )
}

export default CompanyCertManagement
